import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Component({
  selector: 'app-manage-faqs',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  @ViewChild('faqModal') faqModal: ElementRef;
  @ViewChild('sectionModal') sectionModal: ElementRef;

  public isSaving: boolean = false;
  public activeTab: any = null;
  public sections: Array<any> = [];

  public faqs: Array<any> = [];
  public filteredFaqs: Array<any> = [];
  public selectedFaq: any = null;
  public selectedSection: any = null;

  public faqForm: FormGroup = new FormGroup({
    question: new FormControl('', Validators.required),
    answer: new FormControl('', Validators.required),
    order: new FormControl('', Validators.required),
  });

  public sectionForm: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
  });

  constructor(private modalService: NgbModal, private toastr: ToastrService, private auth: AuthServiceService) { }

  ngOnInit(): void {
  
    this.getAllSection();
  }

  public getAllSection() {
    this.auth.getAllFaqSection().subscribe((resp: ApiResponse) => {
      this.sections = resp.body;
      this.activeTab = this.activeTab? this.activeTab :this.sections[0].id;
      this.getFaq(this.activeTab);
    });



  }

  public getFaq(id) {
    this.auth.getAllFaqQuestionBySection(id).subscribe((resp: ApiResponse) => {
      this.filteredFaqs = resp.body;
    });
  }

  setActiveTab(section: any) {
    this.activeTab = section.id;
    this.getFaq(this.activeTab);
  }

  // filterFaqs() {
  //   this.filteredFaqs = this.faqs.filter((faq) => faq.sectionId === this.activeTab);
  // }

  openFaqModalForAddEdit(faq?: any) {
    this.selectedFaq = faq || null;
    if (faq) {
      this.faqForm.patchValue({
        question: faq?.question,
        answer: faq?.answer,
        order: faq?.orderIndex,
      });
    } else {
      this.faqForm.reset();
    }
    this.modalService.open(this.faqModal, {
      backdrop: 'static',
      windowClass: 'my-upload-event-modal',
    });
  }

  saveFaq() {
    this.isSaving = true; 
    const faq = this.faqForm.value;


    let payload = {
      sectionId: this.activeTab,
      question: this.faqForm.value.question,
      answer: this.faqForm.value.answer,
      // imageUrl: req.body.imageUrl,
      orderIndex: this.faqForm.value.order,
    }

    if (this.selectedFaq) {
      payload['id'] = this.selectedFaq.id;

    }


    this.auth.addFaqQuestion(payload).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.modalService.dismissAll();
      this.getAllSection();
      this.isSaving = false; 
    });

  }

  deleteFaq(id: number) {
    this.auth.deleteFaqQuestion(id).subscribe((resp: ApiResponse) => {
      this.toastr.success('FAQ deleted successfully');
      this.getFaq(this.activeTab);
    });
  }

  openSectionModal(section?: any) {
    this.selectedSection = section || null;
    if (section) {
      this.sectionForm.patchValue({

        name: section?.sectionName,
        description: section?.description,
      });
    } else {
      this.sectionForm.reset();
    }
    this.modalService.open(this.sectionModal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });
  }

  saveSection() {
    const section = this.sectionForm.value;
    let payload = {
      sectionName: section.name,
      description: section.description,
    };
    if (this.selectedSection) {
      // const index = this.sections.indexOf(this.selectedSection);
      // this.sections[index] = section;
      payload['id'] = this.selectedSection.id;

    } else {
      // this.sections.push(section);
    }

    this.auth.addFaqSection(payload).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.modalService.dismissAll();
      this.getAllSection();
    });


  }

  deleteSection(id) {
    this.auth.deleteFaqSection(id).subscribe((resp: ApiResponse) => {
      this.toastr.success('Section deleted successfully');
      this.getAllSection();
    });

  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }
}
